__turbopack_context__.v({
  "caption": "styles-module-scss-module__4NBi1G__caption",
  "classNameContent": "styles-module-scss-module__4NBi1G__classNameContent",
  "classNameRoot": "styles-module-scss-module__4NBi1G__classNameRoot",
  "content": "styles-module-scss-module__4NBi1G__content",
  "description": "styles-module-scss-module__4NBi1G__description",
  "root": "styles-module-scss-module__4NBi1G__root",
  "title": "styles-module-scss-module__4NBi1G__title",
});
